import React, { lazy, Suspense, useEffect } from "react";

//routing imports
import { Route, Router, Switch } from "react-router-dom";

//HMR
import { hot } from "react-hot-loader";

//components static

import history from "./history";

import { frontEnd } from "./config/links";

//import LogRocket from "logrocket";

import Http404Page from "./pages/http404page";

// import Profile from "./pages/authorization/profile";
// import ResetPassword from "./pages/authorization/reset-password";
import Home from "./pages/home";
import Purchase from "./pages/Dashboard/purchase";
import { useUserContext } from "./context/user-context";
import { appFetch } from "./helpers/app-fetch";
import useLocalStorage from "./helpers/use-local-stroage";

//
//dashbaord pages
//
// import Revise from "./pages/Dashboard/revise";
//LogRocket.init("zdz1em/getthru");

const ResendConfirmEmail = lazy(() =>
  import("./pages/authorization/resend-confirm-email")
);
const Admin = lazy(() => import("./pages/admin"));
const Profile = lazy(() => import("./pages/authorization/profile"));
const ResetPassword = lazy(() =>
  import("./pages/authorization/reset-password")
);
const ConfirmEmail = lazy(() => import("./pages/authorization/confirm-email"));
const Revise = lazy(() => import("./pages/Dashboard/revise"));
const Review = lazy(() => import("./pages/Dashboard/review"));
const ReviewReport = lazy(() => import("./pages/admin/review-report"));

const SingleUpload = lazy(() => import("./pages/admin/addQuestion"));
const BulkUpload = lazy(() => import("./pages/admin/bulk-upload"));
const ExamEnd = lazy(() => import("./pages/Dashboard/examEnd"));
const Results = lazy(() => import("./pages/Dashboard/results"));
const Dashboard = lazy(() => import("./pages/Dashboard/dashboard-wrapper"));
const DashboardHome = lazy(() => import("./pages/Dashboard/home"));

const GSSE = lazy(() => import("./pages/gsse"));
const BPS = lazy(() => import("./pages/bps"));
const GPEPAU = lazy(() => import("./pages/gpep/au"));
const GPEPNZ = lazy(() => import("./pages/gpep/nz"));

const App = () => {
  return (
    <Router history={history}>
      {/* <NavBar /> */}
      <Suspense fallback={<div></div>}>
        <Switch>
          <Route
            path="/(login/index.html|register/index.html|login|register|register-success|forgot-password|forgot-password/index.html|confirm-email|confirm-email/index.html|closed-for-alpha|resend-confirm-email|reset-password|)/"
            component={Home}
          />
          <Route path={frontEnd.profile} exact component={Profile} />

          <Route path={frontEnd.bulkUpload} exact component={BulkUpload} />
          <Route path={frontEnd.reviewReports} exact component={ReviewReport} />
          <Route path={frontEnd.singleUpload} exact component={SingleUpload} />
          <Route path={frontEnd.results} component={Results} />
          <Route path={frontEnd.review} exact component={Review} />

          <Route path={frontEnd.admin} exact component={Admin} />
          <Route path={frontEnd.confirmEmail} exact component={ConfirmEmail} />
          <Route
            path={frontEnd.resendConfirmEmail}
            component={ResendConfirmEmail}
          />
          <Route
            path={frontEnd.resetPassword}
            exact
            component={ResetPassword}
          />
          {/* <Route path={frontEnd.forgotPassword} component={ForgotPassword} /> */}
          <Route path="/dashboard">
            <DashboardRoutes />
          </Route>
          <Route path={frontEnd.gsse} component={GSSE} />
          <Route path={frontEnd.bps} component={BPS} />
          <Route path={frontEnd.gpepau} component={GPEPAU} />
          <Route path={frontEnd.gpepnz} component={GPEPNZ} />
          <Route component={Http404Page} />
        </Switch>
        <Switch></Switch>
      </Suspense>
    </Router>
  );
};

const DashboardRoutes = () => {
  const { userState, setStateUserState } = useUserContext();

  const query = new URLSearchParams(window.location.search);

  const forcePurchaseRedirect = query.get("forcePurchaseRedirect");

  const [redirectToPurchase, setRedirectToPurchase] = useLocalStorage(
    "purchaseRedirect",
    false
  );

  //i want to set the redirect to purchase to true if the user is not logged in and forcePurchaseRedirect is true
  // useEffect(() => {
  //   console.log(userState.attributes.checkedIfUserLoggedIn, userState.attributes.email, forcePurchaseRedirect);
  //   if (userState.attributes.checkedIfUserLoggedIn && userState.attributes.email == "" && forcePurchaseRedirect) {
  //     setRedirectToPurchase(true);
  //   }
  // }, []);

  useEffect(() => {
    let checkIfUserIsActive = async () => {
      let response = await appFetch("/api/auth/validate", {
        method: "GET"
      });

      console.log(response);
    };
    if (!userState?.attributes?.checkedIfUserLoggedIn) {
      checkIfUserIsActive();
    }
  }, []);

  if (!userState?.attributes?.exam) {
    return null;
  }
  return (
    <Dashboard>
      <Suspense fallback={<div></div>}>
        <Switch>
          <Route path={frontEnd.dashboardHome} component={DashboardHome} />
          <Route path={frontEnd.revise} exact component={Revise} />
          <Route path={frontEnd.testResults} exact component={ExamEnd} />
          <Route path={frontEnd.purchase} exact component={Purchase} />
        </Switch>
      </Suspense>
    </Dashboard>
  );
};

export { history };

//@ts-ignore

export default hot(module)(App);
